import type { KeyTakeawayBlock, LocaleCode } from '@fixit/bozp-content';
import { Markdown } from '../markdown';

export function KeyTakeawayBlockView({
  block,
  locale,
}: {
  block: KeyTakeawayBlock;
  locale: LocaleCode;
}) {
  return (
    <aside data-block-type="keyTakeaway" role="note">
      <Markdown markdown={block.markdown} locale={locale} />
    </aside>
  );
}
